var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.60156V16.6016H15V4.60156H5ZM4.5 3.60156H15.5C15.646 3.60156 15.7658 3.64839 15.8595 3.74206C15.9532 3.83573 16 3.95556 16 4.10156V17.1016C16 17.2476 15.9532 17.3674 15.8595 17.4611C15.7658 17.5548 15.646 17.6016 15.5 17.6016H4.5C4.354 17.6016 4.23417 17.5548 4.1405 17.4611C4.04683 17.3674 4 17.2476 4 17.1016V4.10156C4 3.95556 4.04683 3.83573 4.1405 3.74206C4.23417 3.64839 4.354 3.60156 4.5 3.60156ZM7 10.6016H13V11.6016H7V10.6016ZM7 7.60156H10V8.60156H7V7.60156ZM7 13.6016H13V14.6016H7V13.6016Z",
    fill: "",
    stroke: "",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketsIcon);
export default __webpack_public_path__ + "static/media/tickets-icon.bbbfd49714c237736eddba8d3c5a6481.svg";
export { ForwardRef as ReactComponent };